<template>
  <div id="app">
    <HeaderBar
      :page-name="'resilientcity'"
      facebookShareURL="https://udn.com/newmedia/921/resilientcity/" 
      lineShareURL="https://udn.com/newmedia/921/resilientcity/"
    />
    <Anchor
      :currentPage="currentPage"
      :PAGE_AMOUNT="PAGE_AMOUNT"
      :partNumber="1"
    />
    <div id="cover" :class="{'point-event-disabled': enterContent}">
      <Cover
        :coverPage1Flag="coverPage1Flag"
        :coverPage2Flag="coverPage2Flag"
      />
    </div>
    <div v-show="enterContent" id="longform-content">
      <div class="container-bg-black">
        <div class="container">
          <h1>921再震一次<br>台灣準備好了嗎？</h1>
          <p>中央氣象局統計，從1900年以來，台灣<span style="color: red">平均每17.14年</span>會有一個規模超過7的陸地大震，死傷人數皆超過百人，在這人人可以活到90歲的時代，每個人一生中可能得碰上5次。令人膽戰心驚的是，上一次的大震已是<span style="color: red">20年</span>前重創台灣的921地震。</p>
          <p>面對隨時可能發生的強震，我們只能提前做好準備，來減少死傷與損失。如今台灣地震預警技術比20年前先進，若再發生一次921大地震，距離震央極近的<strong>台中市多7秒時間求生</strong>，但科技爭取到黃金救命秒數，政府若未正視地質風險、未建立完整防救災規畫，多幾秒恐也無用。</p>
        </div>
      </div>
      <div class="container">
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <h2>救命救錢的幾秒鐘</h2>
      </div>
      <div class="containerFull">
        <img
          width="100%"
          :src="selectDevice(
            require('./assets/images/921_part1_cover.jpg'),
            require('./assets/images/pad1.jpg'),
            require('./assets/images/921_part1_cover_pc.jpg'),
          )"
          alt="921再震一次 台灣準備好了嗎？"
        >
      </div>
      <div class="container">
        <p>半導體龍頭、年收入近一兆台幣的台積電，是個不允許「震動」的地方。</p>
        <p>正在運作的台積電廠房突然接到警示，再過幾秒將發生預估4級地震，已預先連動所有機台的系統立刻動起來，關閉所有機台電源、暫停產線，過沒幾秒鐘，地震開始搖了，台積電因為提早接到預警、即時應變，避免可能的上千萬損失。</p>
        <p>國家地震工程研究中心研究員林沛暘指出，2、3級的地震晃一下，都可能讓台積電整批貨作廢，若能透過先進的預警技術得知地震將來，台積電可以立刻關電源、暫停生產，或啟動應變措施、加強基台穩定度。</p>
      </div>
      <div class="containerFull">
        <div class="containerImage">
          <img
            class="containerImage_image"
            width="100%"
            :src="selectDevice(
              require('./assets/images/921_part1_image2.jpg'),
              require('./assets/images/pad_img4.jpg'),
              require('./assets/images/pad_img4.jpg'),
            )"
            alt="921再震一次 台灣準備好了嗎？"
          >
          <p class="containerImage_description">2016年南台大地震，南部科學工業園區全區停工，災損至少數十億，半導體大廠台積電原本評估兩到三天可全面復工，卻因設備破壞程度超過想像，復工日期延後。圖／報系資料照</p>
        </div>
      </div>
      <div class="container">
        <h3>921地震重來一次 台中能有7秒應變</h3>
        <p>台積電的情境不是想像，而是已實際在運作的預警機制。1999年的921地震造成全台超過3千600億元災損，921地震發生後，中央氣象局、國家地震工程研究中心開始發展地震速報，結合現地型、區域型兩種預警機制，為民眾爭取黃金救命秒數。</p>
        <p>以921大地震為例，離震央僅52公里的台中市，在感受到搖晃前多<span style="color: red">7秒</span>可以救命；離震央152公里遠的台北市有多達<span style="color: red">31秒</span>的時間可以逃生避護，氣象局估算，若1999年時有這套技術，台北市可以減少<span style="color: red">78％傷亡比</span>，鄰近的嘉義縣市、苗栗縣，傷亡比也可少3成。</p>
      </div>
      <div class="containerFull">
        <img
          width="100%"
          :src="selectDevice(
            require('./assets/images/921_part1_background_image1.jpg'),
            require('./assets/images/pad_img1.jpg'),
            require('./assets/images/921_part1_background_image1_pc.jpg'),
          )"
          alt="921再震一次 台灣準備好了嗎？"
        >
      </div>
      <div class="container">
        <p>氣象局地震測報中心主任陳國昌指出，地震分
          <span style="color:#57b09f">P波和S波</span>
          <button name="explanation-button" class="explanation-button" @click="handleDictionaryClick()">解釋</button>
          <span v-show="explanationFlag" class="explanation-container"><strong>P波和S波<br><br></strong>地震分為P波和S波，P波跑得較快，約每秒5.5公里，P波抵達時民眾會開始感受到晃動，而真正易造成損害的是隨後抵達的S波，現行地震速報機制便是利用密集測站快速接收到P波，抓緊時間差發送預警到民眾手機提醒應變。</span>
          ，氣象局透過密集的測站可以快速收到跑得快的P波，判斷震央位置和預估震度，搶在震波到達前發送速報到民眾手機。過去震央周圍50.4公里是「預警盲區」，但氣象局和國震中心近年積極研發「現地型預警」，離震央近的地區也可以接到預警。
        </p>
        <p>以2019年4月18日發生的花蓮銅門地震為例，氣象局的預警系統從接受到地震震波，到民眾手機接到速報，時間已提升到僅需14秒，氣象局規劃年底前將再增加測站數量，預估可將速度提升至10秒，為各地爭取更多時間。</p>
        <h3>運用一：地震預警＋智慧居家＝減少災情</h3>
        <p>林沛暘指出，預警技術可以運用的面向很廣泛，不只是發速報到民眾手機，更可以和產業配合、實際融入民眾生活。例如智慧居家、保全業、第四台、廣告看板、智慧音箱、手錶等，都是可能的運用方向。</p>
        <p>他舉例，中興保全近年發展智慧居家，有7萬名用戶在使用「中保無限＋」設備服務，國震中心與其合作，未來地震發生、收到警報時，智慧居家系統會自動把門打開、關瓦斯、開燈，指引民眾要往哪逃生、可以躲在哪，避免受傷和二次災情。預計今年將開始做體驗服務。</p>
        <h3>運用二：地震風災摧殘 社區靠科技求生</h3>
        <p>「居安思危，有備無患」用在南投縣水里鄉上安村最貼切不過。這個小山村曾經歷颱風、大地震和土石流摧殘，面對大自然的無情撥弄，居民勇敢面對，透過災情預警系統和救災聯防訓練，讓上安村自然災害共存，並成為台灣災情預警示範社區。</p>
        <p>上安村多災多難，從民國85年到90年間，上安村遭遇三次重大天災，85年賀伯颱風一天降下1千多毫米大雨，陳有蘭溪暴漲成災；921大地震，40戶房子倒塌。民國90年的桃芝颱風，因地震鬆動的山坡地帶來驚人土石流，路和橋斷了、房子被沖走，17條生命就此消逝。</p>
      </div>
      <div class="containerFull">        
        <div class="containerImage">
          <img
            class="containerImage_image"
            width="100%"
            :src="selectDevice(
              require('./assets/images/921_part1_image3.jpg'),
              require('./assets/images/pad_img2.jpg'),
              require('./assets/images/921_part1_image2_pc.jpg'),
            )"
            alt="921再震一次 台灣準備好了嗎？"
          >
          <p class="containerImage_description">如今看來好山好水的南投縣水里鄉上安村，難以想像曾因風災、地震，全村一片狼藉。圖／記者黑中亮攝影</p>
        </div>
      </div>
      <div class="container">
        <p>接連三次的天災打擊讓居民灰心，「颱風、地震及土石流頻傳，為何不願搬家？」外界常這樣問前村長張豐富，但他總說：「我們一輩子務農，除了種田，又還能做什麼？」想留下，就得面對天災威脅。</p>
        <p>居民配合水保局設置土石流觀測站，設置雨量計、CCD、地聲檢知器、鋼索檢知器及水位計等儀器設備，讓颱風豪雨來襲前，可以靠數據及早掌握訊息。如今，水保局資料可以與社區居民使用的防災監測警示系統結合，提前發預警訊息告知全村。</p>
        <p>長期走訪上安社區的中華經濟研究院能源與環境研究中心研究員李永展建議，擁有地震預警技術的國震中心、氣象局可以參考水保局的做法，與社區現有的防災警示系統結合，社區民眾統一接到訊息，就可以啟動社區已經預先排練好的應變措施、逃生計畫，更有效率預防災情發生。</p>
      </div>
      <div class="containerFull bg-gray">
        <div class="container">
          <div class="people-can-do">
            <div class="tips">
              Tips
            </div>
            <h3 v-if="isMob">多了那幾秒<br>民眾可以做什麼</h3>
            <h3 v-if="!isMob">多了那幾秒&nbsp民眾可以做什麼</h3>
            <div class="principle-container">
              <div class="principle">
                <div class="principle-title">
                  原則一
                </div>
                <div class="principle-content">
                  時間有限下先不要往戶外衝，待主震停後再往外移動。
                </div>
              </div>
              <div class="principle">
                <div class="principle-title">
                  原則二
                </div>
                <div class="principle-content">
                  平時應預先在居家、校園、辦公室找好可以躲避的空間。
                </div>
              </div>
            </div>
            <hr>
            <div class="place-and-do">
              <div class="place-and-do-title">
                <div class="left-container">人在哪裡</div>
                <div class="right-container">可以做什麼</div>                
              </div>
              <div class="place-and-do-content">
                <div class="left-container"> 客廳、餐廳、書房</div>
                <div class="right-container"> 盡可能躲在桌下（玻璃桌面的桌子除外）、抓穩桌腳。</div>
              </div>
              <div class="place-and-do-content">
                <div class="left-container"> 浴室、廁所</div>
                <div class="right-container"> 廁所中支柱較多相對耐震，留在原地勿驚慌，注意牆上懸掛的鏡子、置物架上物品是否會掉落。</div>
              </div>
              <div class="place-and-do-content">
                <div class="left-container"> 床上</div>
                <div class="right-container"> 留在床上，並利用枕頭或棉被保護頭部直到地震結束。</div>
              </div>
              <div class="place-and-do-content">
                <div class="left-container"> 辦公室</div>
                <div class="right-container"> 躲進辦公桌下，切勿往上看，以免被破碎的日光燈碎片刺傷。</div>
              </div>
              <div class="place-and-do-content">
                <div class="left-container"> 學校</div>
                <div class="right-container"> 在教室中立刻躲進桌下；若在走廊上就地蹲低抱頭避難。</div>
              </div>
            </div>
            <div class="resouces">資料來源／內政部消防署、國家災害防救科技中心</div>
          </div>
        </div>
      </div>
      <div class="containerFull bg-blue">
        <div class="container">
          <div class="next-page">
            <a href="./fault/" @click="sendGA('然後呢頁尾按鈕1')">
              <p>下一篇</p>
              <h2>斷層旁住滿人</h2>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';
import Hammer from 'hammerjs';
import _debounce from 'lodash.debounce';

import Anchor from './components/Anchor.vue';
import Cover from './components/cover/Cover.vue';

import HeaderBar from '../../general_components/HeaderBar.vue';

const VueScrollTo = require('vue-scrollto');

export default {
  name: 'app',
  components: {
    Anchor,
    Cover,
    HeaderBar,
  },
  data() {
    return {
      currentPage: 0,
      PAGE_AMOUNT: 2,
      coverPage1Flag: false,
      coverPage2Flag: false,
      explanationFlag: false,
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 768 ? true : false;
    },
    enterContent() {
      return this.currentPage === this.PAGE_AMOUNT ? true : false;
    },
  },
  watch: {
    currentPage: {
      handler(page) {
        switch (page) {
          case 0:
            this.coverPage1Flag = true;
            this.coverPage2Flag = false;
            break;
          case 1:
            this.coverPage1Flag = false;
            this.coverPage2Flag = true;
            break;
        }
      },
      deep: true,
    },
  },
  methods: {
    selectDevice(mob, pad, pc) {
      if (window.innerWidth < 768) {
        return mob;
      } else if (window.innerWidth >=768 && window.innerWidth <= 1024) {
        return pad;
      } else {
        return pc;
      }
    },
    handleWheel: _debounce(function(e) {
      // 閱讀內文
      if (this.currentPage < this.PAGE_AMOUNT) {
        if (e.deltaY > 0) {
          this.handleSwpiePage('up');
        }
        if (e.deltaY < 0) {
          this.handleSwpiePage('down');
        }
      }
    }, 200),
    handleScroll() {
      if (this.currentPage === this.PAGE_AMOUNT && window.pageYOffset === 0) {
        this.currentPage--;
      }
    },
    handleSwpiePage(dir) {
      switch (this.currentPage) {
        case 0:
          this.updatePage(dir);
          break;
        case 1:
          this.updatePage(dir);
          setTimeout(() => {
            VueScrollTo.scrollTo('#longform-content');
          }, 300);
          break;
      }
    },
    updatePage(dir) {
      this.currentPage = dir === 'up' ? ++this.currentPage : --this.currentPage;
      if (this.currentPage < 0) {
        this.currentPage = 0;
      }
      if (this.currentPage > this.PAGE_AMOUNT) {
        this.currentPage = this.PAGE_AMOUNT;
      }
    },
    handleDictionaryClick() {
      this.explanationFlag = !this.explanationFlag;
      this.sendGA('然後呢辭典');
    },
    sendGA(target) {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "button",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [" + target + "]"
      });
    },
  },
  mounted() {
    const appController = document.getElementById('cover');
    if (window.innerWidth > 768) {
      appController.addEventListener('wheel', e => { this.handleWheel(e); }, true);
    }
    window.addEventListener('scroll', this.handleScroll);
    const hammerController = new Hammer(appController);
    hammerController.get('swipe').set({
      direction: Hammer.DIRECTION_VERTICAL,
      threshold: 5,
    });
    hammerController.on("swipeup", () => {
      this.handleSwpiePage('up');
    });
    hammerController.on("swipedown", () => {
      this.handleSwpiePage('down');
    });

    this.coverPage1Flag = true;
  },
  destroyed() {
    if (window.innerWidth > 768) {
      const appController = document.getElementById('cover');
      appController.removeEventListener('scroll', this.handleWheel);
    }
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss">
  @font-face {
    font-family: Ming;
    src: url('assets/fonts/ARMingB5Medium.ttf');
  }
  .point-event-disabled {
    pointer-events: none;
  }
  .container-bg-black {
    position: relative;
    padding: 25% 0;
    background-color: #000000;
    color: #ffffff;
    p, h1, h2, h3, h4 {
      color: #ffffff;
    }
  }
  #longform-content {
    .container {
      h2 {
        font-family: Ming;
        font-weight: bold;
        text-align: center;
      }
    }
    .containerFull {
      margin-top: 0;
    }
    .bg-gray {
      background-color: #f2efee;
      margin: 0;
    }
    .bg-blue {
      background-color: #152235;
      margin: 0;
    }

    .explanation-button {
      border: none;
      border-radius: 4px;
      color: #ffffff;
      background-color: #57b09f;
      cursor: pointer;
      padding: 4px 5px;
      margin: 0 3px;
    }
    .explanation-container {
      display: block;
      border-radius: 6px;
      padding: 30px;
      margin: 1rem 0;
      background-color: #c3dddd;
    }

    .people-can-do {
      padding: 20% 20px;
      @media only screen and (min-width: 769px) {
        padding: 10% 20px;
      }
      hr {
        height: 1px;
        border: none;
        background-color: #ccb69b;
      }
      .tips {
        height: 36px;
        width: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-bottom: 10px;
        color: #ffffff;
        background-color: #ccb69b;
      }
      .principle-container {
        position: relative;
        margin: 50px 0;
        @media only screen and (min-width: 769px) {
          margin: 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;        
        }
        .principle {
          margin: 50px 0;
          @media only screen and (min-width: 769px) {
            &:first-child {
              margin-right: 25px;
            }
            &:last-child {
              margin-left: 25px;
            }
          }
          .principle-title {
            color: #ccb69b;
            margin-bottom: 10px;
          }
        }
      }
      .place-and-do {
        position: relative;
        margin: 50px 0;
        .place-and-do-title {
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: #ccb69b;
          margin-bottom: 10px;
          .left-container {
            position: relative;
            width: 30%;
            padding-right: 10px;
          }
          .right-container {
            position: relative;
            width: 70%;
            padding-left: 40px;
          }
        }
        .place-and-do-content {
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 20px 0;
          .left-container {
            position: relative;
            width: 30%;
            padding-right: 10px;
          }
          .right-container {
            position: relative;
            width: 70%;
            padding-left: 40px;
          }
        }
      }
      .resouces {
        font-size: 0.8rem;
        color: #7b7a7a;
      }
    }
    .next-page {
      position: relative;
      height: 35vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      a {
        text-decoration: none;
        color: inherit;
      }
      p, h2 {
        color: #ffffff;
        font-family: Ming;
        text-align: center;
      }
    }
  }
</style>
